import {
  DiffOutlined,
  FullscreenOutlined,
  OrderedListOutlined,
} from '@ant-design/icons'
import { constantsDictionary } from './dictionary'
import { ROUTES } from './routes'
import { IMenuItems } from './types'

export const mainMenuList: IMenuItems[] = [
  // Ikki bo'lim vaqtincha yashirilgan — ikkalasi ham hozir saytga ta'sir
  // qilmaydi, ya'ni muharrirni chalg'itadi:
  //
  // "Content Section" — banner, o'quv turlari, rasmlar, izohlar. Bular
  //   eski saytga mo'ljallangan va yangi saytda umuman ishlatilmaydi.
  // "SEO" — sayt sarlavhasi va tavsifi. Yangi sayt bu qiymatlarni hali
  //   API'dan o'qimaydi (ular layout.tsx da qattiq yozilgan), shuning
  //   uchun bu yerga kiritilgan matn hech qayerda ko'rinmaydi.
  //
  // Marshrutlar (/content/edit, /seo) o'z joyida — qaytarish uchun
  // shu ro'yxatga elementni tiklash yetarli. Content uchun qo'shimcha:
  // router'dagi index yo'nalishini ham o'zgartirish kerak.
  {
    label: constantsDictionary.blogs,
    icon: <FullscreenOutlined />,
    key: ROUTES.blogsPosts,
    children: [
      {
        label: constantsDictionary.blog,
        key: ROUTES.blogsPosts,
        icon: <DiffOutlined />,
      },
      {
        label: constantsDictionary.categories,
        key: ROUTES.blogsCategories,
        icon: <OrderedListOutlined />,
      },
    ],
  },
]
